/** Set true to show the LLM price intelligence feed above the chart. */
export const PRICE_INTELLIGENCE_FEED_ENABLED = false;

/** Set true to render mock feed content without calling the backend. */
export const PRICE_INTELLIGENCE_FEED_USE_MOCK = true;

/** Set true to show layers, historical chart, intraday drill-down, and related chart UI. */
export const STOCK_CHART_UI_ENABLED = true;

/** Set true to show the Market Prediction card on the dashboard. */
export const DASHBOARD_MARKET_PREDICTION_ENABLED = false;

/** Set true to show the Cross Day Analogue Analysis card on the dashboard. */
export const DASHBOARD_CROSS_DAY_ANALOGUE_ENABLED = false;

/** Set true to show the Sector Analysis card on the dashboard. */
export const DASHBOARD_SECTOR_ANALYSIS_ENABLED = true;

/** Set true to show the Major Stories section on the dashboard. */
export const DASHBOARD_MAJOR_STORIES_ENABLED = false;

/** Set true to show the Storylines section on the dashboard. */
export const DASHBOARD_STORYLINES_ENABLED = false;

/** Set true to show the Trades section on the dashboard. */
export const DASHBOARD_TRADES_ENABLED = false;

/** Set true to show the Upcoming Earnings section on the dashboard. */
export const DASHBOARD_UPCOMING_EARNINGS_ENABLED = false;

/** Set true to show the Stock Comparison card on the dashboard. */
export const DASHBOARD_STOCK_COMPARISON_ENABLED = false;

/** Set true to fetch and run stock attractiveness scoring (frontend + backend orchestration). */
export const STOCK_ATTRACTIVENESS_ENABLED = false;

/** Set true to show the AI Receipt / overlooked BOM stack article on the dashboard. */
export const DASHBOARD_AI_RECEIPT_STACK_ENABLED = true;

/** Set true to show the Merlin AI assistant tab on the dashboard. */
export const DASHBOARD_MERLIN_ENABLED = true;

/** Set true to show the Value Chain explorer tab and dashboard section. */
export const DASHBOARD_VALUE_CHAIN_ENABLED = true;

/** Set true to show the QXO bottom-up investor desk tab and dashboard section. */
export const DASHBOARD_QXO_ENABLED = true;

/**
 * Local `npm run dev` talks to the VIC warehouse desk on localhost:8000.
 * Production stays on mock replies — VIC chat is not mounted on Fly.io.
 */
export const MERLIN_USE_VIC_CHAT = import.meta.env.DEV;

/** Set true to use mock Merlin replies without calling the backend. */
export const MERLIN_USE_MOCK = !MERLIN_USE_VIC_CHAT;
